import React from 'react';
import styled from 'styled-components';

const C7Style = styled.svg``;

export const C7 = ({ color }) => {
	return (
		<C7Style
			xmlns='http://www.w3.org/2000/svg'
			width='18.695'
			height='22.836'
			viewBox='0 0 18.695 22.836'
		>
			<path
				id='grammaphone'
				d='M883.342,470.315H884.5l-.035-.034v0a2.2,2.2,0,0,1-.451-.665h-2.722a3,3,0,0,1-1.774-.531,2.863,2.863,0,0,1-1.064-1.5c-1.22-3.9,3.245-5.891,6.046-6.983,3-1.17,6.435-2.512,8.161-6.787a.858.858,0,0,1,.674-.58.847.847,0,0,1,.984.692l2.613,14.851h0a.864.864,0,0,1-.353.842.855.855,0,0,1-1.191-.2c0-.009-2.077-3.054-7.862-3.054h-3.787c-1.694,0-1.67,1.54,0,1.54h.274a2.154,2.154,0,1,1,3.5,2.378v0l-.036.034h5.87a1.557,1.557,0,0,1,1.093.452l.061.073a1.516,1.516,0,0,1,.388,1.017v3.336a.855.855,0,0,1-.857.857H882.649a.855.855,0,0,1-.851-.857v-3.336a1.537,1.537,0,0,1,.451-1.091,1.557,1.557,0,0,1,1.093-.452Zm-2.577-2.5c-.68-1.814,1.167-3.175,2.971-3.175h3.787a12.9,12.9,0,0,1,7.291,1.994l-1.749-9.932c-2.115,3.208-5.2,4.412-7.948,5.484-1.811.708-5.882,2.16-5.031,4.88a1.1,1.1,0,0,0,.68.751Zm4.777.927v.012h0v.013a.409.409,0,0,0,.127.3v0l.012.006a.444.444,0,0,0,.3.122.414.414,0,0,0,.309-.127l.006,0,.006-.009a.441.441,0,0,0,.122-.3.433.433,0,0,0-.127-.313l-.006,0-.006-.008a.441.441,0,0,0-.3-.119.456.456,0,0,0-.316.128l-.025.027a.443.443,0,0,0-.1.277Zm5.741-9.051a.511.511,0,0,1,.65.79,14.488,14.488,0,0,1-2.492,1.641c-.862.45-1.743.83-2.643,1.2a.514.514,0,0,1-.382-.954c.875-.353,1.726-.724,2.546-1.151a13.559,13.559,0,0,0,2.321-1.523Zm1.891,12.335h-9.662v2.31h9.662v-2.31Z'
				transform='translate(-878.244 -453.215)'
				fill={color}
			/>
		</C7Style>
	);
};
